import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useFirebase } from '@web/firebase';
export var SignOut = function () {
    var signOut = useFirebase().signOut;
    var history = useHistory();
    useEffect(function () {
        signOut();
        history.push('./');
    }, []);
    return (React.createElement(React.Fragment, null));
};
